import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "24",
  width: "24",
  id: "View-1--Streamline-Ultimate",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "View 1 Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("g", { id: "View-1--Streamline-Ultimate" }, [
      _createElementVNode("path", {
        d: "M23.43 10.52c-2.64 -2.91 -7 -6 -11.43 -5.92S3.21 7.61 0.57 10.52a2.22 2.22 0 0 0 0 3C2.33 15.42 6.74 19.4 12 19.4s9.66 -4 11.43 -5.93a2.22 2.22 0 0 0 0 -2.95ZM7.4 12a4.6 4.6 0 1 1 4.6 4.6A4.6 4.6 0 0 1 7.4 12Z",
        fill: "currentcolor",
        "stroke-width": "1"
      }),
      _createElementVNode("path", {
        d: "M10 12a2 2 0 1 0 4 0 2 2 0 1 0 -4 0",
        fill: "currentcolor",
        "stroke-width": "1"
      })
    ], -1)
  ])))
}
export default { render: render }